export const ADD_TO_HANGER = "ADD_TO_HANGER";
export const ADD_TO_YARDAGE = "ADD_TO_YARDAGE";
export const SUBTRACT_TO_HANGER = "SUBTRACT_TO_HANGER";
export const SUBTRACT_TO_YARDAGE = "SUBTRACT_TO_YARDAGE";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CLEAR_CART = "CLEAR_CART";
